import React,{useState} from 'react'
import { useTranslation} from "react-i18next";

import {images} from '../../constants'
import {AppWrap,MotionWrap} from '../../wrappers'
import {client} from '../../client'
import './Footer.scss'

const Footer = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({name:'',email:'',message:''})
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const {name,email,message}=formData

  const handleInputChange= (e) => {
    const {name,value} = e.target

    setFormData({ ...formData, [name]: value})
  }

  const handleSubmit =() => {
    setLoading(true)

    const contact = {
      _type: 'contact',
      name:name,
      email:email,
      message:message
    }

    client.create(contact)
      .then(()=> {
        setLoading(false)
        setIsFormSubmitted(true)
      })

  }


  return (
   <>
   <h2 className='head-text'>{t('footer-header-text')}</h2>

   <div className='app__footer-cards'>
     <div className='app__footer-card'>
       <img src={images.email} alt="email" />
       <a href="mailto:sami_kachai@live.com" className='p-text'>Sami_Kachai@live.com</a>
     </div>
     <div className='app__footer-card'>
       <img src={images.mobile} alt="mobile" />
       <a href="tel:+216 20 674 080" className='p-text'>+216 (20) 674-080</a>
     </div>
   </div>

    {!isFormSubmitted ?    <div className='app__footer-form app__flex'>
     <div className='app__flex'>
       <input className='p-text' type="text" placeholder={t('name-placeholder')}  value={name} onChange={handleInputChange} name="name" />
     </div>
     <div className='app__flex'>
       <input className='p-text' type="email" placeholder={t('email-placeholder')}  value={email} onChange={handleInputChange} name="email" />
     </div>
     <div>
       <textarea className='p-text' placeholder={t('message-placeholder')} value={message} name="message"  onChange={handleInputChange} cols="30" rows="10"></textarea>
     </div>
     <button type='button' className='p-text' onClick={handleSubmit}>{loading ? t('button-sending'):t('footer-button')}</button>
   </div>: 
   <div>
     <h3 className='head-text'>Thank you for getting in touch!</h3>
   </div>}

   </>
  )
}

export default AppWrap(
  MotionWrap(Footer,'app__footer'),
  'contact',
  "app__whitebg"
  )